<div id="container">
    <label class="container" >
        <input type="checkbox" [checked]="isCompleted">
        <span class="mark" (click)="toggleComplete()"></span>
      </label>
      <div  id="{{currentId}}" class="title"  (blur)="updateTitle()" contenteditable="true" [ngClass]="isCompleted ? 'strikethrough' : 'null'">{{title}}</div>
</div>

